import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ApiUrls } from '../../../config/api-urls/api-urls';
import { MainService } from '../../../provider/main.service';
declare var $ : any;

@Component({
  standalone: false,
  selector: 'app-program-type-mgt',
  templateUrl: './program-type-mgt.component.html',
  styleUrls: ['./program-type-mgt.component.css']
})
export class ProgramTypeMgtComponent implements OnInit {

  programList: any = [];
  itemPerPage = 10;
  currentPage = 1;
  total: any;
  programId: any;

  constructor(public service : MainService , private router : Router ) { }

  ngOnInit() {
     this.viewProgramList();
  }
   
  // program list api inntegration 
   viewProgramList(){
     this.service.showSpinner();
     this.service.getApi(ApiUrls.programType_list + `?pageNumber=${this.currentPage}&limit=${this.itemPerPage}`,1).subscribe((res)=>{
      this.service.hideSpinner();
      if (res.responseCode==200){
        this.programList = res.result;
        this.total = res.paginationData.total;
        this.currentPage = res.paginationData.page;

      }
      else{
        this.service.errorToast(res.responseMessage)
      }
    },err=>{
      this.service.hideSpinner();
     this.service.errorToast(err.responseMessage)
     })
   }

   pagination(event: any) {
    this.programList = [];
    this.currentPage = event;
    this.viewProgramList()
  }

  // delete Program api integration 

  deleteProgram (){
    const data = {
      _id : this.programId,
      status : "DELETE"
    }
    this.service.showSpinner();
    this.service.postApi(ApiUrls.actionPerform_programType,data ,1).subscribe((res)=>{
     this.service.hideSpinner();
     if (res.responseCode==200){
       this.programList = res.result;  
       this.service.successToast('Program type deleted successfully')
       $('#deleteUser').modal('hide')
       this.viewProgramList();
     }
     
   },err=>{
     this.service.hideSpinner();
    this.service.errorToast(err.responseMessage)
    })
  }
   
  deleteUserModal(id: any){
    this.programId = id ;
    $('#deleteUser').modal('show')
  }
}
